export const formatApplicationVersion = (version: string): string => {
  // version is provided from outside of the application (safe type is hard to guarantee)
  if (!version) {
    return ''
  }
  const versionPart = version.split('.')
  const formatVersion = versionPart.splice(0, 3)
  return formatVersion.join('.')
}
